export default __webpack_public_path__ + "static/media/logo-us-fao-schwartz.7f78c46b.svg";